import React, { useState } from "react";
// import emailjs from "@emailjs/browser";
import { Link, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { submitContact } from '../../apis/contactApis';
import Loader from '../Loader/Loader';

const menu = [
  { label: "Home", link: "/" },
  { label: "About", link: "/about" },
  { label: "Services", link: "/services" },
  { label: "Industries", link: "/industries" },
  { label: "Products", link: "/product" },
  // { label: "Career", link: "/career" },
  { label: "Blog", link: "/blog" },
  { label: "Career", link: "/career" },


];

function Header() {
  const pathname = useLocation().pathname;
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showMegaMenu, setShowMegaMenu] = useState(false);
  const [showIndustriesMenu, setShowIndustriesMenu] = useState(false);

  return (
    <>
      <div className="fixed top-0 w-full z-[100] bg-[#FFFFFF] py-[12.5px]">
        <div className="flex items-center justify-between max-w-[1440px] w-full mx-auto lg:px-[50px] px-[20px]">
          <Link to="/">
            <img src="/assets/nav/logo.svg" alt="Logo" className="w-[140px]" />
          </Link>
          <ul className="hidden lg:flex items-center gap-[50px] relative">
            {menu.map((e, i) => {
              if (e.label === "Products") {
                return (
                  <div
                    key={i}
                    className="relative"
                    onMouseEnter={() => setShowMegaMenu(true)}
                    onMouseLeave={() => setShowMegaMenu(false)}
                  >
                    <li className={`font-[400] font-kanit text-[18px] leading-[28px] capitalize border-b-[2px] text-[#000000] ${pathname === e.link ? "border-[#000000]" : "border-transparent"}`}>
                      <Link to={e.link}>Products</Link>
                    </li>
                    {showMegaMenu && (
                      <div
                        className="absolute top-[30px] left-0 bg-white shadow-xl px-[20px] py-[20px] z-[90] w-[300px]"

                        onMouseEnter={() => setShowMegaMenu(true)}
                        onMouseLeave={() => setShowMegaMenu(false)}
                      >

                        <div className="flex-1 min-w-[250px] nav-drop font-kanit">
                          <Link to='/product-detail'>
                            <li>Junction Box & Enclosures</li>

                          </Link>
                          <Link to='/ipconnectors'>
                            <li>IP68 Re-enterable Gel & Connectors</li>

                          </Link>

                         
                          <Link to='/GlandsAccessories'>
                            <li>Cable Accessories</li>

                          </Link>
                          <Link to='/TerminationTools'>
                            <li>Cable Termination & Tools</li>

                          </Link>
                       

                          <Link to='/CableManagementSystem'>
                            <li>Cable Management</li>

                          </Link>
                           <Link to='/PowerInstrumentation'>
                            <li>Cables</li>

                          </Link>
                          <Link to='/Cableties'>
                            <li>In-Ground Power Supply Units</li>

                          </Link>

                          <Link to='/HeatShrink'>
                            <li>Electrical Bulk - Oil & Gas</li>

                          </Link>
                       
                          <Link to='/InstrumentationBulk'>
                            <li>Instrumentation Bulk - Oil & Gas</li>

                          </Link>






                        </div>



                      </div>
                    )}
                  </div>
                );
              }

              if (e.label === "Industries") {
                return (
                  <div
                    key={i}
                    className="relative"
                    onMouseEnter={() => setShowIndustriesMenu(true)}
                    onMouseLeave={() => setShowIndustriesMenu(false)}
                  >
                    <li className={`font-[400] font-kanit text-[18px] leading-[28px] capitalize border-b-[2px] text-[#000000] ${pathname === e.link ? "border-[#000000]" : "border-transparent"}`}>
                      <Link to={e.link}>Industries</Link>
                    </li>

                    {/* {showIndustriesMenu && (
                    <div className="fixed top-[72px] left-0 right-0 bg-white shadow-xl px-[80px] py-[40px] z-[90] flex gap-[60px] overflow-x-auto max-h-[90vh]">
                    
                      <div className="flex-1 min-w-[300px]">
                      <Link to='/landscape'>

                         <div className='id-cards'>
   <div className='id-cards-img'>
<img src='/assets/img1.png'/>
                      </div>
                      <h3>Landscape</h3>
                     
                      </div>
                      </Link>


                      <Link to='/utilities'>

                        <div className='id-cards'>
   <div className='id-cards-img'>
<img src='/assets/img1.png'/>
                      </div>
                      <h3>Utilities</h3>
                     
                      </div>
                      </Link>

                      </div>

                   
                      <div className="flex-1 min-w-[300px]">
                      <Link to='/oilgas'>

                      <div className='id-cards'>
   <div className='id-cards-img'>
<img src='/assets/img1.png'/>
                      </div>
                      <h3>Oil & Gas</h3>
                     
                      </div>
                      </Link>
                      <Link to='/construction'>

                          <div className='id-cards'>
   <div className='id-cards-img'>
<img src='/assets/img1.png'/>
                      </div>
                      <h3>Construction</h3>
                     
                      </div>
                      </Link>

                      </div>

                      <div className="flex-1 min-w-[300px]">
                      <Link to='/solar'>

                        <div className='id-cards'>
   <div className='id-cards-img'>
<img src='/assets/img1.png'/>
                      </div>
                      <h3>	Solar</h3>
                      
                      </div>
                      </Link>
                      <Link to='/industrial'>

                         <div className='id-cards'>
   <div className='id-cards-img'>
<img src='/assets/img1.png'/>
                      </div>
                      <h3>Industrial</h3>
                    
                      </div>
                      </Link>

                      </div>
                    </div>
                  )} */}
                  </div>
                );
              }

              return (
                <li
                  key={i}
                  className={`font-[400] font-kanit text-[18px] leading-[28px] capitalize border-b-[2px] text-[#000000] ${pathname === e.link ? "border-[#000000]" : "border-transparent"}`}
                >
                  <Link to={e.link}>{e.label}</Link>
                </li>
              );
            })}
          </ul>
          <button onClick={() => setIsModalOpen(true)}
            className="lg:flex hidden items-center justify-center gap-[12px] font-kanit font-[400] text-[17px] leading-[26px] bg-[#FBB210] text-[#FFFFFF] py-[14px] px-[20px] border border-[#FFFFFF] rounded-full group transition-all duration-300">
            Contact Us
            <img
              src="/assets/nav/arrow.svg"
              alt="	Trusted cable management and termination solutions provider in the UAE"
              className="transition-transform duration-300 group-hover:rotate-[42deg] group-hover:scale-150 rotate-[0deg]"
            />
          </button>
          <button
            className="lg:hidden z-[101]"
            onClick={() => setSidebarOpen(true)}
          >
            <img src="/assets/nav/bars-solid.svg" alt="Menu" className="w-[24px]" />
          </button>
        </div>
      </div>

      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-[99]"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}

      <div
        className={`fixed top-0 right-0 w-[280px] h-full bg-[#FBB210] z-[100] p-[24px] transform transition-transform duration-300 ${sidebarOpen ? 'translate-x-0' : 'translate-x-full'}`}
      >
        <div className="flex justify-end mb-6">
          <button onClick={() => setSidebarOpen(false)} className="text-white text-3xl font-bold">
            &times;
          </button>
        </div>
        <ul className="flex flex-col gap-6 mb-10">
          {menu.map((e, i) => (
            <li key={i} className="text-white font-kanit text-[18px]">
              <Link to={e.link} onClick={() => setSidebarOpen(false)}>
                {e.label}
              </Link>
            </li>
          ))}
        </ul>
        <button onClick={() => setIsModalOpen(true)}
          className="flex lg:hidden items-center justify-center gap-[12px] font-kanit font-[400] text-[17px] leading-[26px] bg-[#FBB210] text-[#FFFFFF] py-[14px] px-[20px] border border-[#FFFFFF] rounded-full group transition-all duration-300">
         Contact Us
          <img
            src="/assets/nav/arrow.svg"
            alt="	Trusted cable management and termination solutions provider in the UAE"
            className="transition-transform duration-300 group-hover:rotate-[42deg] group-hover:scale-150 rotate-[0deg]"
          />
        </button>
      </div>

      <PopupModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
}

export default Header;

const PopupModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    user_name: "",
    user_email: "",
    user_mobile: "",
    user_service: "",
    user_message: "",
  });
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // emailjs
    //   .send(
    //     "service_b3qu7gh", // Your Service ID
    //     "template_t3zs0ae", // Your Template ID
    //     formData, // Template parameters
    //     "sc-VOkXfA2NJNSpMv" // Your Public Key
    //   )
    //   .then(
    //     (result) => {
    //       alert("Message sent successfully!");
    //       setFormData({
    //         user_name: "",
    //         user_email: "",
    //         user_mobile: "",
    //         user_service: "",
    //         user_message: "",
    //       });
    //       onClose();
    //     },
    //     (error) => {
    //       console.log(error.text);
    //       alert("Failed to send message, please try again.");
    //     }
    //   );

    try {
      setLoading(true);
      await submitContact({
        firstName: formData.user_name,
        email: formData.user_email,
        phoneNumber: formData.user_mobile,
        service: formData.user_service,
        message: formData.user_message,
      });
      toast.success('Message sent successfully! We will get back to you soon.');
      setFormData({
        user_name: "",
        user_email: "",
        user_mobile: "",
        user_service: "",
        user_message: "",
      });
      onClose();
    } catch (err) {
      const msg = err?.response?.data?.message || 'Failed to send message. Please try again.';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      {loading && <Loader />}
      <div className="bg-white p-6 rounded-xl w-[90%] max-w-lg shadow-xl relative">
        <button
          className="absolute top-3 right-3 text-xl font-bold text-gray-700 hover:text-red-600"
          onClick={onClose}
        >
          &times;
        </button>
        <h6 className="font-[500] font-kanit lg:text-[32px] text-[24px] lg:leading-[38px] leading-[30px] text-[#000000] pb-[30px]">
          Let’s Stay Connected With Us
        </h6>
        <form onSubmit={handleSubmit}>
          <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-[30px] gap-x-0 gap-y-[23px]">
            <input
              name="user_name"
              placeholder="Your Name *"
              type="text"
              value={formData.user_name}
              onChange={handleChange}
              className="border border-[#0922101A] rounded-[10px] py-[19px] px-[22px] font-[400] font-kanit text-[17px] text-[#092210B2]"
              required
            />
            <input
              name="user_mobile"
              placeholder="Phone Number *"
              type="text"
              value={formData.user_mobile}
              onChange={handleChange}
              className="border border-[#0922101A] rounded-[10px] py-[19px] px-[22px] font-[400] font-kanit text-[17px] text-[#092210B2]"
              required
            />
            <input
              name="user_email"
              placeholder="Email Address *"
              type="email"
              value={formData.user_email}
              onChange={handleChange}
              className="border border-[#0922101A] rounded-[10px] py-[19px] px-[22px] font-[400] font-kanit text-[17px] text-[#092210B2]"
              required
            />
            <input
              name="user_service"
              placeholder="Service type"
              type="text"
              value={formData.user_service}
              onChange={handleChange}
              className="border border-[#0922101A] rounded-[10px] py-[19px] px-[22px] font-[400] font-kanit text-[17px] text-[#092210B2]"
            />
            <div className="lg:col-span-2 col-span-1">
              <textarea
                name="user_message"
                placeholder="Message"
                rows="3"
                value={formData.user_message}
                onChange={handleChange}
                className="w-full border border-[#0922101A] rounded-[10px] py-[19px] px-[22px] font-[400] font-kanit text-[17px] text-[#092210B2]"
                required
              ></textarea>
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            className="py-[15px] px-[35px] rounded-[50px] font-[500] font-kanit text-[15px] leading-[24px] bg-[#FBB210] hover:bg-transparent border border-transparent hover:border-[#FBB210] transition-all ease-in text-[#FFFFFF] hover:text-[#FBB210] mt-[20px] mb-[16px] disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {loading ? 'Sending...' : 'Submit Now'}
          </button>
        </form>
      </div>
    </div>
  );
};
